import { render, staticRenderFns } from "./MultiEvento.vue?vue&type=template&id=03575daf&"
import script from "./MultiEvento.vue?vue&type=script&lang=js&"
export * from "./MultiEvento.vue?vue&type=script&lang=js&"
import style0 from "./MultiEvento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports